import { Injectable } from '@angular/core';
import { AppState, OAuthService } from './oauth.service';
import { FronteggAuthService as FronteggAuth } from '@frontegg/angular';
import { firstValueFrom } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable()
export class FronteggAuthService implements OAuthService {
  private logOutRedirectUrl: string = window.location.protocol + '//' + window.location.host + '/';

  constructor(
    private fronteggAuthService: FronteggAuth
  ) { 
  }

  async login(state?: { [key: string]: any; }): Promise<void> {
    window.localStorage.setItem('FRONTEGG_AFTER_AUTH_REDIRECT_URL', `${window.location.pathname}`)
    await this.fronteggAuthService.loginWithRedirect();
  }
  
  async handleRedirect(): Promise<AppState> {
    throw new Error('Method not supported for frontegg authentication.');
  }

  async getAccessToken(): Promise<string> {
    const user = await firstValueFrom(
      this.fronteggAuthService.user$.pipe(
        filter(u => u != null)
      )
    );
    return user.accessToken;
  }

  async logout(): Promise<void> {    
    this.fronteggAuthService.logout(() => {
      window.location.href = this.logOutRedirectUrl;
    });
  }

  async isAuthenticated(): Promise<boolean> {
    const state = await firstValueFrom(this.fronteggAuthService.authState$);
    return state.isAuthenticated;
  }
}
